import { combineReducers } from 'redux'
import informeAdministracionReducer from './informes-administracion-reducer'
import descargaCasosReducer from './descarga-casos-reducer';

const appReducers = combineReducers({
  informeAdministracionReducer,
  descargaCasosReducer
})

export default appReducers
